import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_FILE_CATEGORIES',
    icon: 'MoreVerticalIcon',
    route: 'file-categories',
    companyOnly: true,
    action: constants.action.permissionFileCategoryView,
    resource: constants.resource.fileCategories,
  },
]
